import { createContext } from 'react';

import { IBDSiteHostResults } from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  siteData: IBDSiteHostResults;
  totalRecords: number;
}

export default createContext<Context>({
  loading: false,
  siteData: null,
  totalRecords: 0,
});
